import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function NotFoundPage() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center gap-4 py-20">
            <h1 className="text-muted text-6xl font-bold">404</h1>
            <p className="text-muted text-lg">{t("errors.notFoundDescription")}</p>
            <Link
                to="/"
                className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-4 py-2 text-sm font-medium transition-colors"
            >
                {t("errors.goHome")}
            </Link>
        </div>
    );
}
